import {Component} from '@angular/core';

@Component({
    selector: 'course-getting-started-support-article',
    template: `
        <ng-container i18n="@@support.articles.gettingStarted">
            <p>Starting with Tyyp in your school is easy! Register your school in minutes and get instant access to the free tracking platform.</p>
            <p>Registering your school is <strong>free</strong>, there are <strong>no fixed costs</strong> for your school.</p>
            <p>
                <a routerLink="/school-registration" mat-flat-button color="primary">Register your school</a>
            </p>
            <h2>The tracking platform</h2>
            <p>After registering your school, you will immediately gain access to the tracking platform. With the help of this platform, it becomes child's play to enroll and follow up students' progress.</p>
            <ul>
                <li><strong>Classes:</strong> create one or more classes to group your students.</li>
                <li><strong>Students:</strong> enroll your students in the course and track their progress in detail.</li>
                <li><strong>Instructors:</strong> create additional instructors and assign them to the classes they follow.</li>
                <li><strong>Exercises:</strong> add your own exercises or tests to the course if you wish.</li>
            </ul>
        </ng-container>
    `
})
export class GettingStartedSupportArticleComponent {
}
